import { GraphQLFormattedError } from "graphql";

var banReasons: string[] | null = null;

const setBanReasons = (reasons: string[]): void => {
    banReasons = reasons;
    localStorage.setItem('@coingoback:banReasons', JSON.stringify(reasons));
}

export const clearBanReasonsIfAny = (): void => {
    const wasBanned = userIsBanned();

    banReasons = null;
    localStorage.removeItem('@coingoback:banReasons');

    if (wasBanned && window.location.pathname === '/banned') {
        window.location.href = '/';
    }
}

export const getBanReasons = (): string[] => {
    if (banReasons !== null) {
        return banReasons;
    }

    if ( typeof window !== 'undefined' && localStorage) {
        let reasons: string[] = localStorage.getItem('@coingoback:banReasons')
            ? JSON.parse(localStorage.getItem('@coingoback:banReasons') as string)
            : [];

        banReasons = reasons;
    } else {
        return [];
    }

    return banReasons;
}

export const userIsBanned = (): boolean => {
  return getBanReasons().length > 0;
}

const onUserBanned = (reasons: string[]): void => {
    setBanReasons(reasons);

    if (window.location.pathname !== '/banned') {
        window.location.href = '/banned';
    }
}

export const handleAuthenticationErrorOnGraphQL = (error: GraphQLFormattedError<Record<string, any>>): boolean => {

    if (error.message !== 'user-is-banned') {
        return false;
    }

    const reasons: string[] = error.extensions?.reason
        ? JSON.parse(error.extensions.reason)
        : ['unspecified'];

    onUserBanned(reasons);

    return true;
}